import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ValidatedDatePickerComponent } from '@app/ui-components/validated-date-picker/validated-date-picker.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { ValidatedNumberInputComponent } from '@app/ui-components/validated-number-input/validated-number-input.component';
import { NotCompletedLoanFormGroup } from './not-completed-loan-form.helper';

@Component({
  selector: 'app-not-completed-loan-form',
  imports: [
    ReactiveFormsModule,
    ValidatedInputComponent,
    ValidatedNumberInputComponent,
    ValidatedDatePickerComponent,
  ],
  templateUrl: './not-completed-loan-form.component.html',
  styleUrl: './not-completed-loan-form.component.scss',
})
export class NotCompletedLoanFormComponent {
  formGroup = input.required<FormGroup<NotCompletedLoanFormGroup>>();
  protected translationKey = 'notComplemtedLoanForm.';
}
